import React from "react";
import { ClockBg, CLockFace } from "./LoaderElements";

const Loader = () => {
  return (
    <ClockBg>
      <CLockFace />
    </ClockBg>
  );
};

export default Loader;
